// extracted by mini-css-extract-plugin
export default {"addButton":"ExternalPartners_addButton__tEnPN"};